import React from 'react';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import 'normalize.css';
import Box from '@mui/material/Box';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

import {
  PRODUCT_NAME,
  TITLE_PRODUCT_NAME
} from './constants/global';

import { PAGE } from './constants/url';
import AppRoute from './route/routes';


const App = () => {
  // const location = useLocation();
  // const currentPage = _.filter(PAGE, el => el.path === location.pathname);
  // const currentTitle = currentPage.length > 0 ? `${currentPage[0].title}${TITLE_PRODUCT_NAME}` : `${PRODUCT_NAME}`
  // document.title = currentTitle;

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <AppRoute />
      </Box>
    </ThemeProvider>
  );
}

export default App;
